export default __webpack_public_path__ + "static/media/Loading.67f992b1.gif";